"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    resolver: function() {
        return resolver;
    }
});
var _core = require("@mantine/core");
var _colourconstantspartner = /*#__PURE__*/ _interop_require_default(require("../colour-constants-partner"));
var _dates = require("@mantine/dates");
var _DatePickerInputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/DatePickerInput.module.css"));
var _DatePickermodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/DatePicker.module.css"));
var _InputWrappermodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/InputWrapper.module.css"));
var _Inputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/Input.module.css"));
var _TextInputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/TextInput.module.css"));
var _PasswordInputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/PasswordInput.module.css"));
var _Buttonmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/Button.module.css"));
var _Anchormodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/Anchor.module.css"));
var _Paginationmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/Pagination.module.css"));
var _Titlemodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/partnerTheme/Title.module.css"));
var _index = require("../lib/index");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var HEADING_LINE_HEIGHT = "1.25";
var resolver = function(param) {
    var _param_other = param.other, headerNavBg = _param_other.headerNavBg, headerNavColor = _param_other.headerNavColor, brandColor = _param_other.brandColor, splashColor = _param_other.splashColor;
    return {
        variables: _extends({
            "--header-nav-bg": headerNavBg,
            "--header-nav-color": headerNavColor,
            "--brand-color": brandColor,
            "--splash-color": splashColor
        }, (0, _index.prefixCSSVars)(_colourconstantspartner.default)),
        dark: {},
        light: {}
    };
};
var BRAND_COLOR = _colourconstantspartner.default["brand-collinson"];
var createMantineColorsTuple = function(value) {
    return Array(10).fill(value);
};
var theme = function(param) {
    var fontFamily = (param === void 0 ? {
        fontFamily: "Be Vietnam Pro"
    } : param).fontFamily;
    return {
        other: {
            headerNavBg: "#FFF",
            headerNavColor: "#FFF",
            brandColor: BRAND_COLOR,
            splashColor: "#FFF"
        },
        colors: {
            brandColor: createMantineColorsTuple(BRAND_COLOR)
        },
        primaryColor: "brandColor",
        primaryShade: 9,
        defaultRadius: 4,
        spacing: {
            xs: (0, _core.rem)(8),
            sm: (0, _core.rem)(16),
            md: (0, _core.rem)(24),
            lg: (0, _core.rem)(32),
            xl: (0, _core.rem)(48)
        },
        fontSizes: {
            xs: (0, _core.rem)(12),
            sm: (0, _core.rem)(14),
            md: (0, _core.rem)(16),
            lg: (0, _core.rem)(18),
            xl: (0, _core.rem)(20),
            xxl: (0, _core.rem)(32)
        },
        fontFamily: fontFamily,
        fontFamilyMonospace: fontFamily,
        headings: {
            fontFamily: fontFamily,
            fontWeight: "600",
            sizes: {
                h1: {
                    fontWeight: "300",
                    lineHeight: HEADING_LINE_HEIGHT
                },
                h2: {
                    lineHeight: HEADING_LINE_HEIGHT
                },
                h3: {
                    lineHeight: HEADING_LINE_HEIGHT
                }
            }
        },
        components: {
            Divider: _core.Divider.extend({
                vars: function() {
                    return {
                        root: {
                            "--divider-color": _colourconstantspartner.default["grey-border"]
                        }
                    };
                }
            }),
            DatePickerInput: _dates.DatePickerInput.extend({
                classNames: _DatePickerInputmodulecss.default
            }),
            DatePicker: _dates.DatePicker.extend({
                classNames: _DatePickermodulecss.default
            }),
            InputWrapper: _core.InputWrapper.extend({
                classNames: _InputWrappermodulecss.default
            }),
            Input: _core.Input.extend({
                classNames: _Inputmodulecss.default
            }),
            TextInput: _core.TextInput.extend({
                classNames: _TextInputmodulecss.default
            }),
            PasswordInput: _core.PasswordInput.extend({
                classNames: _PasswordInputmodulecss.default
            }),
            Anchor: _core.Anchor.extend({
                classNames: _Anchormodulecss.default
            }),
            Title: _core.Title.extend({
                classNames: {
                    root: _Titlemodulecss.default.heading
                }
            }),
            Button: _core.Button.extend({
                classNames: function(theme, props) {
                    if (props.variant === "outline") {
                        return {
                            root: _Buttonmodulecss.default.rootOutline
                        };
                    }
                    return {
                        root: _Buttonmodulecss.default.root
                    };
                },
                vars: function(theme, props) {
                    var baseVars = {
                        "--button-padding-x": theme.spacing.md,
                        "--button-fz": (0, _core.rem)(theme.fontSizes.md),
                        "--button-height": (0, _core.rem)(44)
                    };
                    var variantVars = {};
                    if (props.variant === "outline") {
                        variantVars = {
                            "--button-color": _colourconstantspartner.default["text-default"],
                            "--button-bd": "1px solid " + _colourconstantspartner.default["text-default"]
                        };
                    } else if (props.variant === "transparent") {
                        variantVars = {
                            "--button-color": _colourconstantspartner.default["text-default"]
                        };
                    }
                    var combinedVars = _extends({}, baseVars, variantVars);
                    return {
                        root: combinedVars
                    };
                }
            }),
            Alert: _core.Alert.extend({
                vars: function(theme, props) {
                    var color = props.color;
                    var bgAlert = (0, _core.rgba)(color, 1);
                    return {
                        root: {
                            "--alert-bg": bgAlert
                        }
                    };
                }
            }),
            Pagination: _core.Pagination.extend({
                classNames: _Paginationmodulecss.default
            })
        }
    };
};
var _default = theme;
